import { getArrayValue } from "./array";
import { Shader } from "./shader/shader";
import { Texture } from "./texture";
export class Sequence {
    constructor(synth, index) {
        this.synth = synth;
        this.name = `seq${index}`;
        this.layers = [];
        this.currentIndex = 0;
        this.currentTime = 0;
        this.layerDuration = [];
        this.layerSpeed = [];
        this.running = false;
    }
    init(...layers) {
        this.layers = layers.map((l, i) => {
            const generator = (l instanceof Texture ? l.toGLSLSource() : l).generator();
            const shader = new Shader(this.synth, {
                fragment: generator,
                name: `layer_${this.name}_${i}`,
            });
            shader.compile();
            return shader;
        });
        this.layerDuration = this.layers.map((_, i) => this.layerDuration[i] ?? 1);
        this.layerSpeed = this.layers.map((_, i) => this.layerSpeed[i] ?? 1);
        this.currentIndex = (this.currentIndex + this.layers.length) % this.layers.length;
        this.runnableIndex = this.layers.map((_, i) => i);
        return this;
    }
    out(o = this.synth.defaultOutput) {
        this.output = o;
        this.output.clear();
        return this.start();
    }
    duration(...d) {
        this.layerDuration = this.layers.map((_, i) => d[i % d.length] ?? 1);
        return this;
    }
    speed(...s) {
        this.layerSpeed = this.layers.map((_, i) => s[i % s.length] ?? 1);
        return this;
    }
    start(...layersIndex) {
        if (this.running)
            return this;
        this.currentTime = 0;
        this.runnableIndex = layersIndex.length > 0 ? layersIndex : this.layers.map((_, i) => i);
        this.running = true;
        return this.set(this.currentIndex);
    }
    clear() {
        this.stop();
        this.layers.forEach(l => l.clear());
        this.layers = [];
        this.currentIndex = 0;
        this.currentTime = 0;
        this.layerDuration = [];
        this.layerSpeed = [];
        this.runnableIndex = [];
        return this;
    }
    stop() {
        if (!this.running)
            return this;
        this.running = false;
        return this;
    }
    update(dt) {
        if (!this.running || typeof this.output === "undefined")
            return;
        // check if current out has any of the layers, if not, stop the sequence
        if (!this.layers.includes(this.output.shader)) {
            console.log("Sequence stopped because output shader is not in layers");
            this.stop();
            return;
        }
        const ls = getArrayValue(this.layerSpeed[this.runnableIndex[this.currentIndex]] ?? 1, {
            time: this.synth.time,
            bpm: this.synth.bpm,
        });
        this.currentTime += dt * this.synth.speed * ls;
        const d = getArrayValue(this.layerDuration[this.runnableIndex[this.currentIndex]] ?? 1, {
            time: this.synth.time,
            bpm: this.synth.bpm,
        }) * ls;
        if (this.currentTime > d) {
            this.currentTime = 0;
            this.set((this.currentIndex + 1) % this.runnableIndex.length);
        }
    }
    next() {
        const nextIndex = (this.currentIndex + 1) % this.runnableIndex.length;
        return this.set(nextIndex);
    }
    set(index) {
        const next = this.layers[this.runnableIndex[index]];
        if (next) {
            next._uniforms = next._uniforms.filter(({ name }) => name !== "time");
            next._uniforms.push({
                type: "float",
                name: "time",
                value: () => {
                    const s = getArrayValue(this.layerSpeed[this.runnableIndex[this.currentIndex]] ?? 1, {
                        time: this.synth.time,
                        bpm: this.synth.bpm,
                    });
                    return this.synth.time * s * this.synth.speed;
                },
            });
            this.output.activate(false);
            next.out(this.output);
            // when new shader is attached to output, it will be remove
            // the sequence if exists, so we need to reattach it
            // this.output.sequence = this
            //this.running = true
            this.currentIndex = index;
            this.currentTime = 0;
        }
        return this;
    }
}
